(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3688],{

/***/ 33688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44030);
/* harmony import */ var _howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56399);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39181);





var HowWork = function(param) {
    var data = param.data;
    // Workflow steps data
    var workflowSteps = [
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "22",
                viewBox: "0 0 20 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15 19H14.8C13.1198 19 12.2798 19 11.638 18.673C11.0735 18.3854 10.6146 17.9265 10.327 17.362C10 16.7202 10 15.8802 10 14.2V7.8C10 6.11984 10 5.27976 10.327 4.63803C10.6146 4.07354 11.0735 3.6146 11.638 3.32698C12.2798 3 13.1198 3 14.8 3H15M15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17C15.8954 17 15 17.8954 15 19ZM15 3C15 4.10457 15.8954 5 17 5C18.1046 5 19 4.10457 19 3C19 1.89543 18.1046 1 17 1C15.8954 1 15 1.89543 15 3ZM5 11L15 11M5 11C5 12.1046 4.10457 13 3 13C1.89543 13 1 12.1046 1 11C1 9.89543 1.89543 9 3 9C4.10457 9 5 9.89543 5 11ZM15 11C15 12.1046 15.8954 13 17 13C18.1046 13 19 12.1046 19 11C19 9.89543 18.1046 9 17 9C15.8954 9 15 9.89543 15 11Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Design Your Effect",
            description: "Define your effect logic and GPU kernels using CUDA, OpenCL, or Metal"
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10 3.5H17.3C18.4201 3.5 18.9802 3.5 19.408 3.71799C19.7843 3.90973 20.0903 4.21569 20.282 4.59202C20.5 5.01984 20.5 5.57989 20.5 6.7V8C20.5 8.93188 20.5 9.39783 20.3478 9.76537C20.1448 10.2554 19.7554 10.6448 19.2654 10.8478C18.8978 11 18.4319 11 17.5 11M12 18.5H4.7C3.5799 18.5 3.01984 18.5 2.59202 18.282C2.21569 18.0903 1.90973 17.7843 1.71799 17.408C1.5 16.9802 1.5 16.4201 1.5 15.3V14C1.5 13.0681 1.5 12.6022 1.65224 12.2346C1.85523 11.7446 2.24458 11.3552 2.73463 11.1522C3.10218 11 3.56812 11 4.5 11M9.3 13.5H12.7C12.98 13.5 13.12 13.5 13.227 13.4455C13.3211 13.3976 13.3976 13.3211 13.4455 13.227C13.5 13.12 13.5 12.98 13.5 12.7V9.3C13.5 9.01997 13.5 8.87996 13.4455 8.773C13.3976 8.67892 13.3211 8.60243 13.227 8.5545C13.12 8.5 12.98 8.5 12.7 8.5H9.3C9.01997 8.5 8.87996 8.5 8.773 8.5545C8.67892 8.60243 8.60243 8.67892 8.5545 8.773C8.5 8.87996 8.5 9.01997 8.5 9.3V12.7C8.5 12.98 8.5 13.12 8.5545 13.227C8.60243 13.3211 8.67892 13.3976 8.773 13.4455C8.87996 13.5 9.01997 13.5 9.3 13.5ZM16.8 21H20.2C20.48 21 20.62 21 20.727 20.9455C20.8211 20.8976 20.8976 20.8211 20.9455 20.727C21 20.62 21 20.48 21 20.2V16.8C21 16.52 21 16.38 20.9455 16.273C20.8976 16.1789 20.8211 16.1024 20.727 16.0545C20.62 16 20.48 16 20.2 16H16.8C16.52 16 16.38 16 16.273 16.0545C16.1789 16.1024 16.1024 16.1789 16.0545 16.273C16 16.38 16 16.52 16 16.8V20.2C16 20.48 16 20.62 16.0545 20.727C16.1024 20.8211 16.1789 20.8976 16.273 20.9455C16.38 21 16.52 21 16.8 21ZM1.8 6H5.2C5.48003 6 5.62004 6 5.727 5.9455C5.82108 5.89757 5.89757 5.82108 5.9455 5.727C6 5.62004 6 5.48003 6 5.2V1.8C6 1.51997 6 1.37996 5.9455 1.273C5.89757 1.17892 5.82108 1.10243 5.727 1.0545C5.62004 1 5.48003 1 5.2 1H1.8C1.51997 1 1.37996 1 1.273 1.0545C1.17892 1.10243 1.10243 1.17892 1.0545 1.273C1 1.37996 1 1.51997 1 1.8V5.2C1 5.48003 1 5.62004 1.0545 5.727C1.10243 5.82108 1.17892 5.89757 1.273 5.9455C1.37996 6 1.51997 6 1.8 6Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Develop Kernels",
            description: "Connect processing nodes to create a dynamic, modular workflow"
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "22",
                viewBox: "0 0 20 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17 8C17 11.866 13.866 15 10 15M17 8C17 4.13401 13.866 1 10 1M17 8H3M10 15C6.13401 15 3 11.866 3 8M10 15C11.7509 13.0832 12.7468 10.5956 12.8009 8C12.7468 5.40442 11.7509 2.91685 10 1M10 15C8.2491 13.0832 7.25498 10.5956 7.20091 8C7.25498 5.40442 8.2491 2.91685 10 1M10 15V17M3 8C3 4.13401 6.13401 1 10 1M12 19C12 20.1046 11.1046 21 10 21C8.89543 21 8 20.1046 8 19M12 19C12 17.8954 11.1046 17 10 17M12 19H19M8 19C8 17.8954 8.89543 17 10 17M8 19H1",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Initialize the Framework & Integrate Advanced Features",
            description: "Instantly check for compatibility, then generate optimized builds for each host"
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13ZM16 13V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H11M4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7ZM4 7V19",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Build and Test ",
            description: "Export, test, and fine-tune performance across platforms"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowContent),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowHeader),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_4__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "text-md",
                                color: "grayDark-300",
                                children: "Workflow"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_4__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "display-md",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowTitle),
                                children: "From Concept to Deployment"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_4__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                variant: "text-xl",
                                color: "grayDark-400",
                                children: "Follow a clear, four-step process to go from idea to fully functional, cross-platform video plugin."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowSteps),
                    children: workflowSteps.map(function(step, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_4__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 1000,
                            delay: index * 200,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowCard),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowIcon),
                                        children: step.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_howitwork_module_scss__WEBPACK_IMPORTED_MODULE_3___default().workflowCardContent),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                variant: "text-lg",
                                                as: "h3",
                                                color: "grayDark-50",
                                                weight: "semibold",
                                                children: step.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                                variant: "text-md",
                                                color: "grayDark-400",
                                                children: step.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HowWork);


/***/ }),

/***/ 44030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"workflowContainer":"howitwork_workflowContainer__iSYAx","workflowContent":"howitwork_workflowContent__wTQTF","workflowHeader":"howitwork_workflowHeader__ZAzid","workflowTitle":"howitwork_workflowTitle__TWWrO","workflowSteps":"howitwork_workflowSteps__GX9uS","workflowCard":"howitwork_workflowCard__pcfTR","workflowIcon":"howitwork_workflowIcon__2VAzE","workflowCardContent":"howitwork_workflowCardContent__yS3wH"};

/***/ })

}]);